import { enumToStaticValue } from '@/utils'
import { UserType } from '@/modules/user/type/userType'

export default enumToStaticValue(UserType, 'user-type')
